<template>
<v-item-group class="d-flex" >
  <v-chip :color="sample_tests.some(test => test.sample_test_type_uuid === type.uuid) ? 'error' : ''" class="text-center" v-for="type in testTypes" label small>{{type.name}}</v-chip>
</v-item-group>
</template>

<script>
export default {
  name: "SampleRequiredTests",
  props:{
    sample_tests:{
      required: true,
      type: Array
    }
  },
  computed:{
    testTypes(){
      let types = this.$store.$db().model("sampleTestTypes").query().orderBy("display_order").all();
      let filtered = this.$store.state.filtered_test_types || [];
      if (filtered.length === 0) return types;
      return types.filter(type => {
        if (!filtered.includes(type.uuid)) return true;
        return this.sample_tests && this.sample_tests.some(test => test.sample_test_type_uuid === type.uuid);
      });
    }
  }
}
</script>

<style scoped>

</style>
